document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.textarea-el').forEach((el) => {
    if (el.classList.contains('quill-initialized')) return;

    const toolbarOptions = [
      // Undo / Redo (custom handlers)
      [{ undo: 'undo' }, { redo: 'redo' }],

      // Header
      [{ header: [false, 1, 2, 3, 4, 5, 6] }],

      // Alignment
      [{ align: [] }],

      // Text color
      [{ color: [] }],

      // Formatting
      ['bold', 'italic', 'underline', 'strike', 'code'],

      // Clear formatting
      // ["clean"],

      // Lists
      [{ list: 'ordered' }, { list: 'bullet' }],

      // Media / embed
      ['link', 'image', 'code-block', 'blockquote'],
    ];

    const quill = new window.Quill(el, {
      theme: 'snow',
      modules: {
        toolbar: {
          container: toolbarOptions,
          handlers: {
            undo: function () {
              this.quill.history.undo();
            },
            redo: function () {
              this.quill.history.redo();
            },
          },
        },
        history: {
          delay: 500,
          maxStack: 100,
          userOnly: true,
        },
      },
    });

    el.classList.add('quill-initialized');

    // Sync content to hidden textarea
    const textarea = el.nextElementSibling;

    // load previously added data
    if (textarea.value.trim() !== '') {
      quill.clipboard.dangerouslyPasteHTML(textarea.value);
    }
    quill.on('text-change', () => {
      textarea.value = quill.root.innerHTML;
    });
  });
});
